module.exports = {"460321451":"永兴管委会","460321452":"永乐群岛管委会","460321453":"七连屿管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460321.json
// module id = 2192
// module chunks = 0